import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { JOIN_FONT_PAIRS } from "@wedding/shared";

interface FontPairSelectorProps {
  selected: string | undefined;
  onChange: (fontPair: string) => void;
}

export function FontPairSelector({ selected, onChange }: FontPairSelectorProps) {
  const { t } = useTranslation();
  const th = (key: string) => t(`themes.${key}`);

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {JOIN_FONT_PAIRS.map((pair) => {
        const isSelected = selected === pair.id;
        return (
          <button
            key={pair.id}
            onClick={() => onChange(pair.id)}
            className={[
              "rounded-2xl border-2 p-4 transition-all cursor-pointer text-left",
              isSelected
                ? "border-primary bg-primary/5"
                : "border-border hover:border-primary/40",
            ].join(" ")}
          >
            <div className="flex items-start justify-between mb-2">
              <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
                {pair.label}
              </span>
              {isSelected && <Check className="h-4 w-4 text-primary shrink-0" />}
            </div>
            <p
              className="text-lg font-bold leading-tight text-foreground truncate"
              style={{ fontFamily: `'${pair.heading}', serif` }}
            >
              {th("fontPairHeadingPreview")}
            </p>
            <p
              className="mt-1 text-sm text-muted-foreground"
              style={{ fontFamily: `'${pair.body}', sans-serif` }}
            >
              {th("fontPairBodyPreview")}
            </p>
          </button>
        );
      })}
    </div>
  );
}
